import * as constants from './actions';

const initialState = {
    isSubmitting: false,
    address: {}
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.EMAIL_SUCCESS:
            return {
                ...state,
                completeEmail: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                thankYouText: payload.thankYouText,
                useLocalRepresentative: payload.useLocalRepresentative,
                recipientMask: payload.recipientMask,
                repFullName: payload.repFullName,
                localRepresentativeEmailState: payload.localRepresentativeState
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    thankYouText: payload.thankYouText,
                    thankYouTitle: payload.thankYouTitle,
                    useLocalRepresentative: payload.useLocalRepresentative,
                    localRepresentativeState: payload.localRepresentativeState,
                    id: payload.apiRequestData ? payload.apiRequestData.id : ''
                }
            };
        case constants.EMAIL_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.ON_EMAIL_MESSAGE_CHANGE:
            return {
                ...state,
                isEmailMessageChanged: true
            };
        case constants.ON_GO_TO_STEP2:
            return {
                ...state,
                topic: payload.topic,
                message: payload.message
            };
        case constants.ON_BACK_FROM_STEP2:
            return {
                ...state,
                backButtonClicked: payload
            };
        case constants.EMAIL_SUBMITTING_ERROR:
            return {
                ...state,
                emailSubmitError: payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Email/reducer.js